import { gql } from '@apollo/client';
import { Point, ReplayStopInput, ReplayMetricsFields } from './types';

export interface ComputeReplayMetricsInput {
    warehouseId: number;
    stops: ReplayStopInput[];
}

export interface ReplayMetrics extends ReplayMetricsFields {
    navigationTrajectory?: Point[] | null;
}

export interface ComputeReplayMetricsResponse {
    computeReplayMetrics: ReplayMetrics;
}

export interface ComputeReplayMetricsVariables {
    input: ComputeReplayMetricsInput;
}

export const COMPUTE_REPLAY_METRICS = gql`
    query ComputeReplayMetrics($input: ComputeReplayMetricsInput!) {
        computeReplayMetrics(input: $input) {
            totalDistanceKm
            totalDurationMinutes
            leftTurnCount
            uTurnCount
            trafficLightCount
            navigationTrajectory {
                lat
                lng
            }
        }
    }
`;
